import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';

import {
  RQ_DELETE_PRODUCT_API,
  RQ_GET_ALL_PRODUCT_API,
  RQ_PRODUCTS_BY_FILTER_API,
  RQ_PUT_PRODUCT_API,
  RQ_PUT_UPDATE_PRODUCT_API,
} from './constants';
import {rqCreateMultipartRequest, rqCreateRequest} from './rqHttpUtils';

export const RqGetAllProducts =() => {
  return useQuery({
    queryKey: ['rq_get_all_products'],
    queryFn: async () => {
      const response = await rqCreateRequest(RQ_GET_ALL_PRODUCT_API, null, null);
      return response || [];
    },
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

export const RqUpdateProduct = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_update_product'],
    mutationFn: async ({token, formData, id}) => {
      const url = RQ_PUT_UPDATE_PRODUCT_API.url.replace('<%= id %>', id);
      return rqCreateMultipartRequest(
        {...RQ_PUT_UPDATE_PRODUCT_API, url},
        formData,
        token,
        null,
      );
    },
    ...options,
  });
};

export const RqAddProduct = token => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({token, productData}) => {
      if (!token) {throw new Error('Token is required');}
      if (!productData) {throw new Error('Product data is required');}

      const response = await rqCreateMultipartRequest(
        RQ_PUT_PRODUCT_API,
        productData,
        token,
        null,
      );

      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['rq_get_all_products']});
    },
  });
};

export const RQGetProductsByFilter = (filters, options = {}) => {
  return useQuery({
    queryKey: ['rq_get_products_by_filter', filters], 
    queryFn: async ({queryKey, signal}) => {
      const filtersData = queryKey[1]; 

      const response = await rqCreateRequest(
        RQ_PRODUCTS_BY_FILTER_API,
        null,               
        null,                
        null,                 
        signal,
        'application/json',
        'application/json',
        filtersData,        
      );

      return response;
    },
    enabled: !!filters, 
    ...options,
  });
};
export const RqDeleteProduct = (options = {}) => {  
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rq_delete_product'],
    mutationFn: async ({id, token}) => {
      if (!token) {
        throw new Error('Auth token missing');
      }

      return rqCreateRequest(
        RQ_DELETE_PRODUCT_API,
        null,
        token,
        {id}, 
      );
    },
    onSuccess: () => {  
      queryClient.invalidateQueries({queryKey: ['rq_get_all_products']});
      queryClient.invalidateQueries({queryKey: ['rq_get_products']});
      queryClient.invalidateQueries({queryKey: ['rq_trending_products']});
      queryClient.invalidateQueries({queryKey: ['rq_new_arrivals_products']});
    },
    ...options,
  });  
};
